import {
  facebookAuthRequest,
  getProfile as getProfileRequest,
  login as loginRequest,
  register as registerRequest
} from '../api/auth';
import { removeToken, saveToken } from '../utils/token';
import { getQuestionnairesResults } from '../actions/questionnaires';

export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL';

export const getProfile = () => async dispatch => {
  dispatch({ type: GET_PROFILE_REQUEST });
  try {
    const response = await getProfileRequest();
    dispatch({
      type: GET_PROFILE_SUCCESS,
      user: response && response.data ? response.data.communityUser : null
    });
  } catch (e) {
    dispatch({
      type: GET_PROFILE_FAIL,
      message: e
    });
  }
};

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

const onTokenRetrievalSuccess = async (response, dispatch) => {
  const token = response.data.access_token;
  saveToken(token);
  try {
    const profileResponse = await getProfileRequest();
    dispatch(getQuestionnairesResults());
    dispatch({
      type: LOGIN_SUCCESS,
      user: profileResponse && profileResponse.data ? profileResponse.data.communityUser : null
    });
    return true;
  } catch (e) {
    dispatch({
      type: LOGIN_FAIL,
      message: e
    });
    return false;
  }
};

const onTokenRetrievalFail = (error, dispatch) => {
  dispatch({
    type: LOGIN_FAIL,
    error: error.toObject()
  });
};

export const login = (username, password) => async dispatch => {
  dispatch({ type: LOGIN_REQUEST });
  try {
    const response = await loginRequest(username, password);
    return onTokenRetrievalSuccess(response, dispatch);
  } catch (error) {
    onTokenRetrievalFail(error, dispatch);
  }
};

export const LOGOUT = 'LOGOUT';

export const logout = () => async dispatch => {
  removeToken();
  return dispatch({ type: LOGOUT });
};

export const REGISTRATION_REQUEST = 'REGISTRATION_REQUEST';

export const register = (email, joinEasyvoteSchool) => async dispatch => {
  dispatch({ type: REGISTRATION_REQUEST });
  try {
    const response = await registerRequest(email, joinEasyvoteSchool);
    return onTokenRetrievalSuccess(response, dispatch);
  } catch (response) {
    onTokenRetrievalFail(response, dispatch);
  }
};

export const FACEBOOK_AUTH_REQUEST = 'FACEBOOK_AUTH_REQUEST';

export const authFacebook = facebookToken => async dispatch => {
  dispatch({ type: FACEBOOK_AUTH_REQUEST });
  try {
    const response = await facebookAuthRequest(facebookToken);
    return onTokenRetrievalSuccess(response, dispatch);
  } catch (response) {
    onTokenRetrievalFail(response, dispatch);
  }
};

